import { Circuitry, ArrowSquareOut, Buildings, UsersThree } from "@phosphor-icons/react";
import { BIA_URL } from "@/i18n";
import { Container, Overline, Flow } from "./Section";

export default function SolutionsDigitales({ t }) {
  const d = t.digital;
  const b = d.bia;
  const AUD_ICONS = [UsersThree, Buildings];
  return (
    <section id="solutions-digitales" className="py-24 lg:py-32 bg-white">
      <Container>
        <div className="border-t-2 border-[#0B1B3D] pt-10" data-testid="bu2-block">
          <div className="flex items-center justify-between mb-4">
            <p className="font-heading text-sm font-semibold tracking-[0.2em] uppercase text-[#9AA5B1]">{d.label}</p>
            <Circuitry size={30} weight="light" className="text-[#0B1B3D]" />
          </div>
          <h2 className="font-heading text-3xl md:text-4xl font-semibold tracking-tight text-[#0B1B3D] mb-10" data-testid="bu2-name">
            {d.name}
          </h2>
          <div className="grid lg:grid-cols-12 gap-8 lg:gap-12 mb-16">
            <p className="lg:col-span-5 text-xl md:text-2xl font-medium text-[#2A2D34] leading-snug" data-testid="bu2-title">{d.title}</p>
            <p className="lg:col-span-7 text-base leading-relaxed text-[#5A6B7C]" data-testid="bu2-text">{d.text}</p>
          </div>
          <ul className="grid sm:grid-cols-2 lg:grid-cols-3 gap-px bg-[#E2E8F0] border border-[#E2E8F0]" data-testid="bu2-items">
            {d.items.map((item) => (
              <li key={item} className="bg-white px-6 py-5 font-heading text-base font-semibold tracking-wide text-[#2A2D34] hover:bg-[#F4F5F7] transition-colors">
                {item}
              </li>
            ))}
          </ul>
        </div>

        <article id="bia" data-testid="bia-card" className="mt-16 bg-[#0B1B3D] text-white p-8 lg:p-14">
          <Overline light testid="bia-label" className="mb-5">{b.label}</Overline>
          <div className="grid lg:grid-cols-12 gap-10 lg:gap-16">
            <div className="lg:col-span-5">
              <h3 className="font-heading text-2xl md:text-3xl font-bold tracking-tight mb-6" data-testid="bia-title">{b.title}</h3>
              <p className="text-lg font-medium leading-snug text-white/90 mb-6">{b.hook}</p>
              <p className="text-base leading-relaxed text-white/65 mb-10">{b.text}</p>
              <Flow steps={b.path} light testid="bia-path" />
              <a
                href={BIA_URL}
                target="_blank"
                rel="noopener noreferrer"
                data-testid="bia-cta-button"
                className="mt-12 inline-flex items-center gap-3 bg-white text-[#0B1B3D] font-medium px-8 py-4 hover:bg-[#E2E8F0] transition-colors"
              >
                {b.cta}
                <ArrowSquareOut size={18} weight="light" />
              </a>
            </div>
            <div className="lg:col-span-7 flex flex-col gap-px bg-white/15 border border-white/15">
              {b.audiences.map((aud, i) => {
                const Icon = AUD_ICONS[i];
                return (
                  <div key={aud.name} data-testid={`bia-audience-${i}`} className="bg-[#0B1B3D] p-8 flex gap-5">
                    <Icon size={26} weight="light" className="text-[#8FA1B5] shrink-0 mt-0.5" />
                    <div>
                      <h4 className="font-heading text-sm font-bold tracking-[0.15em] uppercase mb-3">{aud.name}</h4>
                      <p className="text-sm leading-relaxed text-white/65">{aud.text}</p>
                    </div>
                  </div>
                );
              })}
              <div data-testid="bia-programs" className="bg-[#11244D] p-8 border-l-2 border-white">
                <h4 className="font-heading text-xl font-bold tracking-tight mb-3">{b.programs.name}</h4>
                <p className="text-sm leading-relaxed text-white/75">{b.programs.text}</p>
              </div>
            </div>
          </div>
        </article>
      </Container>
    </section>
  );
}
